module.exports = __webpack_public_path__ + "img/etoa.6627472.png";